import ActionTypes from './actionTypes';

// set status
export const setStatus = (message, warning) => ({ type: ActionTypes.SET_STATUS, message, warning });

// clear status
export const clearStatus = () => ({ type: ActionTypes.CLEAR_STATUS });
